import PropTypes from "prop-types";

const propTypes = {
  user: PropTypes.shape({
    I_UZ: PropTypes.number,
    Token: PropTypes.string,
    Roles: PropTypes.array,
    Version: PropTypes.string,
    Uzivatel: PropTypes.shape({
      I_UZ: PropTypes.number,
      N_UZ: PropTypes.string,
      HESLO: PropTypes.string,
      POZN: PropTypes.string,
      ZRUS: PropTypes.bool,
      L_OVERENY: PropTypes.bool,
      L_AKTIV: PropTypes.bool,
      I_GOOGLE: PropTypes.string,
      L_GOOGLE: PropTypes.bool,
      L_ADMIN: PropTypes.bool,

      Osoba: PropTypes.shape({
        OsobneUdaje: PropTypes.shape({
          MENO: PropTypes.string,
          PRIEZVISKO: PropTypes.string,
          NAZOV: PropTypes.string,
          ICO: PropTypes.string,
          I_O_TYP: PropTypes.number,
        }),
        Adresa: PropTypes.shape({
          ULICA: PropTypes.string,
          CS: PropTypes.number,
          CO: PropTypes.string,
          PSC: PropTypes.string,
          OBEC: PropTypes.string,
        }),
        Kontakt: PropTypes.shape({
          EMAIL: PropTypes.string,
          TELEFON: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default propTypes;
